/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BudgetAdvancedFilterDetails {
    getFixupPrototypeFunction() { return BudgetAdvancedFilterDetails.fixupPrototype; }

    static newInstance(model: Partial<BudgetAdvancedFilterDetails>): BudgetAdvancedFilterDetails {
        let obj = Object.assign(new BudgetAdvancedFilterDetails(), model);
        BudgetAdvancedFilterDetails.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BudgetAdvancedFilterDetails>): BudgetAdvancedFilterDetails {
        if (!model) return null;
        return BudgetAdvancedFilterDetails.newInstance(<BudgetAdvancedFilterDetails> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BudgetAdvancedFilterDetails) {
        if (!obj) return;

        models.BudgetAdvancedFilterDetails.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BudgetAdvancedFilterDetails): boolean {
        Object.setPrototypeOf(obj, BudgetAdvancedFilterDetails.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * tag id
     */
    id: string;

    /**
     * tag name
     */
    name: string;

}
